"use client";

import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated use `@faire/slate/icons/Shipping` instead (legacy Slate foundation icons cannot be deleted from code even if unused in frontend because they may be referenced to in Builder.io page data) */
export const Shipping = createSVGIcon(
  <>
    <path
      d="M12.667 10.547h-.002M13.219 21.606a1.33 1.33 0 0 1-1.12.034L2.81 17.675A1.33 1.33 0 0 1 2 16.45V7.397a1.33 1.33 0 0 1 .77-1.208l8.707-4.064a1.33 1.33 0 0 1 1.059-.03l8.625 3.451A1.33 1.33 0 0 1 22 6.783v9.607a1.33 1.33 0 0 1-.737 1.192zM12.667 10.547l9.083-4.541"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m2.237 6.637 10.428 3.91v11.196M16.975 8.393 7.129 4.154"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Shipping",
  { viewBox: "0 0 24 24", fill: "none", className: legacyIconCls() } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
